export default {"src":"/_next/static/media/initUpload.aa754ac4.svg","height":88,"width":203};